import React, { Component } from 'react';
import _ from 'lodash';


import { Grid, Paper, Typography, Table, TableBody, TableRow, TableCell, Checkbox, Button, Link, Chip } from '@material-ui/core';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	CheckCircle as SuccessIcon,
} from "@material-ui/icons";
import { connect } from 'react-redux'
import AddFeedback from "../../../content-request/components/AddFeedback";
import { addNewFeedback, resolveFeedback, replyFeedback } from "../../../content-request/actions/contentRequestActions";
import { bindActionCreators } from "redux";

import { MyPATLink, MyPATExpansionPanel } from '../../../common';
import ContentData from '../../types/ContentData';
import { JEE_MAIN_COURSE_ID, getContentBucketName } from '../../../../utils';

const styles = (theme: Theme) =>
  createStyles({
    divTable: {
      display: "table",
      width: "auto",
      backgroundColor: "#eee",
    },
    feedbackContainer: {
      position: "relative",
      "& .feedbackBlock": {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
    },
    blueColor: {
      color: "#1D7DEA",
    },
    divTableRow: {
      width: "auto",
      display: "flex"
    },
    divTableCol: {
      float: "left",
      display: "table-column",
      width: "185px",
    },
    widthSM: {
      width: 10,
    },
    widthMD: {
      width: "auto",
    },
    marginSM: {
      margin: "0px 4px",
      flex: 1,
    },
    questionPreviewPara: {
      display: "flex",
    },
    questionSerialNum: {
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "1rem",
      lineHeight: "22px",
      color: "#333333",
    },
    optionContainer: {
      marginLeft: 36,
      position: "relative",
    },
    paperOverview: {
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.12) !important",
      borderRadius: 4,
      marginBottom: 16,
      "& p > img, img": {
        maxWidth: "100%",
      },
    },
    keyValueContainer: {
      display: "flex",
      alignItems: "center",
      "& *": {
        display: "inline",
      },
      "& .secondTitle": {
        fontSize: 14,
      },
    },
    viewMoreButton: {
      fontSize: "1rem",
      fontWeight: "normal",
      lineHeight: 0,
      display: "none",
      textDecoration: "underline",
      cursor: "pointer",
    },
    overviewMeta: {
    //   opacity: 0.6,
    },
    fontSM: {
      fontWeight: 600,
      fontSize: "1rem",
      height: 30,
      lineHeight: "22px",
      color: "#333333",
    },
    greyColor: {
      color: "#333333",
    },
    metaInfoBox: {
      padding: theme.spacing.unit,
      marginTop: theme.spacing.unit,
      background: "#FDFDFD",
      border: "1px solid #DDDDDD",
      boxSizing: "border-box",
      borderRadius: 4,
    },
    metaInfoBoxTable: {
      border: 0,
      fontSize: 14,
    },
    paperSyllabus: {
      padding: theme.spacing.unit * 2,
      marginBottom: 16,
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.12)",
      borderRadius: 4,
      "& .subHeading": {
        "& p": {
          fontSize: "16px !important",
        },
      },
    },
    syllabusBox: {
		padding: "15px 5px",
    },
    syllabusSubject: {
    //   opacity: 0.8,
	  marginBottom: 10,
    },
    syllabusContains: {
      background: theme.palette.background.default,
      padding: theme.spacing.unit * 2,
    //   opacity: 0.6,
      borderRadius: 8,
    },
    paperSection: {
      marginBottom: 16,
      borderRadius: 4,
      "&>:first-child": {
        boxShadow: "none",
        border: "solid 1px rgb(241 241 241)",
        marginTop: 16,
      },
    },
    paperSectionTitle: {
      padding: "6px 0px",
    },
    paperSectionContent: {
      background: theme.palette.background.default,
      border: "1px solid rgb(221 221 221)",
      borderRadius: 4,
    },
    paperSectionContentInner: {
      marginTop: `${theme.spacing.unit * 2}px`,
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit}px`,
      background: theme.palette.common.white,
      borderRadius: "4px",
      "&:first-child": {
        marginTop: `0px`,
      },
    },
    lineHightMD: {
      lineHeight: "40px",
    },
    paperSubSectionQuestion: {
      paddingTop: theme.spacing.unit * 2,
      fontSize: "0.9rem",
      "& td": {
        verticalAlign: "baseline", //for future purpose
        textAlign: "justify",
        color: "#333333",
      },
      "& span, & p": {
        fontSize: "16px",
        margin: "0px",
      },
      "& br": {
        display: "none",
      },
      "& p > img, img": {
        maxWidth: "100%",
      },
    },
    paperSubSectionQuestionId: {
      opacity: 0.5,
    },
    optionText: {
      lineHeight: 2,
      "& > span > p": {
        display: "inline",
        marginLeft: theme.spacing.unit,
      },
    },
    questionContentLatex: {
      "& > table > tbody > tr > td:nth-child(odd)": {
        width: "10% !important",
      },
      "& *": {
        margin: 0,
        fontSize: "1rem",
        fontFamily: "'Nunito/', sans-serif",
      },
    },
    successIcon: {
      color: "#30BE76",
      position: "absolute",
      left: -15,
      zIndex: 10,
	  fontSize: 24,
	  marginTop: 2,
    },
    borderBox: {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing.unit,
    },
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },
    checkboxChecked: {
      color: "#59CA1C !important",
    },
    headingFont: {
      fontSize: "1.25rem",
      fontWeight: "bold",
      fontStyle: "normal",
    },
    headingFontPreview: {
      fontSize: "1.25rem",
      fontWeight: "bold",
      fontStyle: "normal",
      minWidth: 165,
    },
    templateType : {
      fontSize: "1.25rem",
    },
    subHeadingFont: {
      fontSize: "1rem !important",
      fontStyle: "normal",
    },
    answerTable: {
      width: "100%",
      "& tbody": {
        "& tr": {
          height: "auto",
          "& td": {
            padding: `${theme.spacing.unit / 2}px 0`,
            border: 0,
            textAlign: "center",
            minWidth: theme.spacing.unit * 10,
            "&:first-child": {
              minWidth: "auto",
            },
            "&:last-child": {
              paddingRight: 0,
            },
          },
        },
      },
    },
    textFullArea: {
      textAlign: "justify",
      display: "inline-block",
      width: "60vw",
    },
    subSectionTypeChip: {
		margin: "0 5px 5px 5px",
		padding: "0px 0 !important",
		display: "inline-flex",
		height: 25,
		lineHeight: 25,
      "& span": {
        fontSize: '13px !important',
        padding: "0 10px !important",
      },
    },
    feedbackHighlight: {
      cursor: "pointer",
      "&:hover": {
        color: "#1d7dea",
      },
    },
	paperContainer:{
		padding: '20px',
	}
  });

//@ts-ignore
interface TestPreviewProps extends WithStyles<typeof styles> {
	classes: any,
	content: ContentData,
	openFeedback: boolean;
	closeFeedback: Function;
	authorType: string;
	contentRequestId: string;
	contentRequestItemId: string;
	addNewFeedback: Function;
	resolveFeedback: Function;
	replyFeedback: Function;
	clickedfeedbackData: any;
	emptyClickedData: Function;
	fromFeedback: boolean;
	handleFeedbackResolve: Function;
	feedbackData: any;

}

interface TestPreviewStates {
	tag: string
}

class TestPreview extends Component<TestPreviewProps, TestPreviewStates>{
	questions: any[] = [
		{ id: 1 },
		{ id: 2 },
		{ id: 3 },
		{ id: 4 },
	]
	constructor(props: TestPreviewProps) {
		super(props);

		this.state = {
			tag: "testName"
				  }
		this.getConceptsTagged = this.getConceptsTagged.bind(this);
		this.section = this.section.bind(this);
		this.subSection = this.subSection.bind(this);
		this.subSectionsQuestions = this.subSectionsQuestions.bind(this);
		this.addNewFeedback = this.addNewFeedback.bind(this);
		this.resolveFeedback = this.resolveFeedback.bind(this);
		this.replyFeedback = this.replyFeedback.bind(this);
		this.closeFeedback = this.closeFeedback.bind(this);
	}
	componentDidUpdate(prevProps: any) {
		if(prevProps.clickedfeedbackData !== this.props.clickedfeedbackData) {
		  if(!_.isEmpty(this.props.clickedfeedbackData)){
	
		  this.setState({
			tag: this.props.clickedfeedbackData.tag
		  })
		} else {
		  this.setState({
			tag: 'testName'
		  })
		}
	  }
	  }


	  addFeedback(tagName: string) {
		if(!_.isEmpty(this.props.clickedfeedbackData)){
		  this.props.emptyClickedData();
		}
		let clickedfeedbackData = this.props.feedbackData && this.props.feedbackData.feedbacksData.filter((feedback: any) =>
		feedback.tag === tagName && !feedback.isResolved
		);
		 if(clickedfeedbackData && clickedfeedbackData.length > 0) {
		 this.props.handleFeedbackResolve(clickedfeedbackData[0])
		}
		setTimeout(() => {
	
		if(this.props.openFeedback) {
		  this.setState({
			tag: tagName
		  })
		}
	  }, 200 );
	 
	  }

	  closeFeedback(){
		this.props.closeFeedback()
	  }
	  addNewFeedback(text: string) {
		let feedbackData = {
		  contentRequestId: this.props.contentRequestId, 
		  contentId: _.get(this.props.content, `content._id`, ""), 
		  comment: text, 
		  role: this.props.authorType, 
		  tag: this.state.tag, 
		  contentRequestItemId: this.props.contentRequestItemId, 
		  contentType: 'test'
		}
		this.props.addNewFeedback(feedbackData)
		this.props.closeFeedback('resolve');
	  }
	  resolveFeedback(id: string) {
		let feedbackData = {
		  feedbackId: id,
		  role: this.props.authorType, 
		  contentRequestItemId: this.props.contentRequestItemId, 
		  contentType: 'test'
		}
		this.props.resolveFeedback(feedbackData)
		this.props.closeFeedback('resolve');
	  }
	  replyFeedback(id: string, text: string) {
		let feedbackData = {
		  feedbackId: id,
		  contentRequestId: this.props.contentRequestId, 
		  contentId: _.get(this.props.content, `content._id`, ""), 
		  comment: text, 
		  role: this.props.authorType, 
		  tag: this.state.tag, 
		  contentRequestItemId: this.props.contentRequestItemId, 
		  contentType: 'test'
		}
		this.props.replyFeedback(feedbackData)
		this.props.closeFeedback('resolve');
	  }

	getConceptsTagged() {
		const { content } = this.props;
		let concepts = "";

		_.map(_.get(content, 'subjects', []), s => {
			s.chapters.forEach(c => {
				c.concepts.forEach(cc => {
					if (concepts != "") {
						concepts + ", ";
					}
					concepts += (cc.conceptId && cc.conceptId.name) || '';
				})
			})
		});

		return concepts;
	}

	getSubSectionName = (section: any) => {
		/* if (section.autoPickSelection) {
			return "Any Topic";
		}
		else */ if (section.courseSyllabusId) {
			return section.courseSyllabusId.name
		}
		else if (section.name) {
			return section.name
		}

		return "";
	}

	section(section: any, i: number = 0) {
		const { classes, content, clickedfeedbackData } = this.props;
		return (
				<Paper classes={{root: classes.paperSection}} elevation={0}>
					<MyPATExpansionPanel
						hasExpandIcon={false}
						defaultExpanded={false}
						variant="white"
						customCollapseTitle={
							<div className={[classes.paperSectionTitle, "subHeading"].join(' ')}>
								<Grid container alignItems="center" justify="space-between">
									<Grid item>
										<div className={!this.props.openFeedback && classes.keyValueContainer}>
											<Typography variant="body2"	
											className={classes.subHeadingFont}>
										Section Name:&nbsp;
									</Typography>
											<Typography variant="body1" className={classes.subHeadingFont}>{this.getSubSectionName(section)}</Typography>
										</div>
									</Grid>
									<Grid item>
										<div className={classes.keyValueContainer}>
											<Typography variant="body2" className='secondTitle'>No. of sub Section:&nbsp;</Typography>
											<Typography variant="body1">{_.get(section, 'subSection', []).length}</Typography>
										</div>
									</Grid>
								</Grid>
							</div>}
					>
						{
							<div className={classes.paperSectionContent}>
								{
									_.map(_.get(section, 'subSection', []), (subSection, j: number) => (
										<div key={j}>{this.subSection(subSection, j)}</div>
									))
								}
							</div>
						}
					</MyPATExpansionPanel>

				</Paper>
		)
	}

	subSection(subSection: any, j: number = 0) {
		const { classes, content, clickedfeedbackData } = this.props;
		const questType = ['SMCQ', 'Matrix', 'True False', 'Blanks', 'Descriptive', 'Paragraph', 'Numerical', 'Integer', 'MMCQ']
		let sectionNegativeMark = _.get(subSection, 'negativeMarks', '-');
		sectionNegativeMark = sectionNegativeMark > 0 ? "-" + sectionNegativeMark : sectionNegativeMark;
		const showJEEMainSpecificFields = this.toShowJEEMainSpecificFields();
		return (

			<div className={classes.paperSectionContentInner}>
				<MyPATExpansionPanel
					hasExpandIcon={false}
					variant="default"
					defaultExpanded={true}
					customCollapseTitle={
						<div className={[!this.props.openFeedback && classes.keyValueContainer, "subHeading"].join(' ')}>
							<Typography variant="body2" className={classes.subHeadingFont}	>
							    Sub Section Name:&nbsp;
								 </Typography>
							<Typography variant="body1">
								{_.get(subSection, 'name', '-')}
								{(
										<Chip color="primary" label={subSection.optionalQuestions ? 'Optional' : 'Mandatory'} className={classes.subSectionTypeChip} variant="outlined" />
								)}
							</Typography>
						</div>}>
					<div className={classes.metaInfoBox}>
						<Grid container>
							<Grid item xs={6}>
								<div className={classes.metaInfoBoxTable}>
									<div className={classes.divTableRow}>
										<div className={classes.divTableCol}>
											<Typography variant="body1">Question Type</Typography>
										</div>
										<div className={[classes.divTableCol, classes.widthSM].join(' ')}>
										<Typography>&#58;</Typography>
										</div>
										<div className={classes.divTableCol}>
										<Typography variant="body1">{questType[subSection.quesCodeAllowed] || ''}</Typography>
										</div>
									</div>
									<div className={classes.divTableRow}>
										<div className={classes.divTableCol}>
										<Typography variant="body1">Total Questions</Typography>
										</div>
										<div className={[classes.divTableCol, classes.widthSM].join(' ')}>
										<Typography>&#58;</Typography>
										</div>
										<div className={classes.divTableCol}>
										<Typography variant="body1">{subSection['noOfQuestions'] || 0}</Typography>
										</div>
									</div>
									{(
										<div className={classes.divTableRow}>
											<div className={classes.divTableCol}>
											<Typography variant="body1">Mandatory Questions</Typography>
											</div>
											<div className={[classes.divTableCol, classes.widthSM].join(' ')}>
											<Typography>&#58;</Typography>
											</div>
											<div className={classes.divTableCol}>
											<Typography variant="body1">{subSection.mandatoryQuestionCount === undefined ? subSection.noOfQuestions : subSection.mandatoryQuestionCount}</Typography>
											</div>
										</div>
									)}
									
								</div>
							</Grid>
							<Grid item xs={6}>
								<div className={classes.metaInfoBoxTable}>
									<div className={classes.divTableRow}>
										<div className={classes.divTableCol}>
										<Typography variant="body1">Marks Per Question</Typography>
										</div>
										<div className={[classes.divTableCol, classes.widthSM].join(' ')}>
										<Typography>&#58;</Typography>
										</div>
										<div className={classes.divTableCol}>
										<Typography variant="body1">{subSection['positiveMarks'] || '-'}</Typography>
										</div>
									</div>
									<div className={classes.divTableRow}>
										<div className={classes.divTableCol}>
										<Typography variant="body1">Par. Marks Per Question</Typography>
										</div>
										<div className={[classes.divTableCol, classes.widthSM].join(' ')}>
										<Typography>&#58;</Typography>
										</div>
										<div className={classes.divTableCol}>
										<Typography variant="body1">{(subSection.partialMarks || '0')}</Typography>
										</div>
									</div>
									<div className={classes.divTableRow}>
										<div className={classes.divTableCol}>
										<Typography variant="body1">Neg. Marks Per Question</Typography>
										</div>
										<div className={[classes.divTableCol, classes.widthSM].join(' ')}>
										<Typography>&#58;</Typography>
										</div>
										<div className={classes.divTableCol}>
										<Typography variant="body1">{sectionNegativeMark}</Typography>
										</div>
									</div>
								</div>
							</Grid>
						</Grid>
					</div>

					{this.subSectionsQuestions(_.get(subSection, 'questions', []), subSection.quesCodeAllowed)}
				</MyPATExpansionPanel>
			</div>
		)
	}

	isChecked = (optionRId: any, correctOption: any) => {
		return correctOption.indexOf(optionRId) > -1;
	}

  getShuffleParamters = () => {
    const { content } = this.props;
    let combinedParams = [];
    if (_.get(content, "content.settings.shuffle.answer", false)) {
      combinedParams.push("Options");
    }
    if (_.get(content, "content.settings.shuffle.questions", false)) {
      combinedParams.push("Questions");
    }
    if (_.get(content, "content.settings.shuffle.sections", false)) {
      combinedParams.push("Sections");
    }
    return combinedParams.join(", ");
  }

	qids: any = null
	paragraphSerialNo = 0;
	renderQuestionScenario(q: any) {
		const { classes, content } = this.props;
		const contentIds =_.get( q,'content_Id.passageData',[]).map((x: any) => x.contentId)
		let isContentIdsExist = false;
		contentIds.forEach((cId: any) => {
			if (this.qids.has(cId) && cId != q.content_Id.contentId) {
				isContentIdsExist = true
			}
		});
		if (isContentIdsExist) {
			contentIds.forEach((cId: any) => {
				this.qids.delete(cId)
			});
			this.paragraphSerialNo += 1
			return (
				<span>
					<strong className={[classes.lineHightMD, classes.greyColor].join(' ')}>Paragraph {this.paragraphSerialNo}:</strong>
					<span className={[classes.fontSM, classes.blueColor].join(' ')}>&nbsp;Scenario</span>
					<Typography variant="body2" dangerouslySetInnerHTML={{ __html: q.qId.content[0].passageQuestion }}></Typography>
				</span>
			)
		}
	}

	handleReadMore() {
		//need to fix according to react structure 

		// let dots = document.getElementById("dots");
		// let moreText = document.getElementById("more");
		// let btnText = document.getElementById("myBtn");

		// if (dots.style.display === "none") {
		// 	dots.style.display = "inline";
		// 	btnText.innerHTML = "Read more";
		// 	moreText.style.display = "none";
		// } else {
		// 	dots.style.display = "none";
		// 	btnText.innerHTML = "Read less";
		// 	moreText.style.display = "inline";
		// }
	}

	subSectionsQuestions(questions: any[], questionCode: number) {
		const { classes, content } = this.props;
    let quesListType = questionCode ;
		if (questionCode === 5) {
			this.paragraphSerialNo = 0
			const contentIds: any = []
      questions &&	questions.map(q => {
				return q && q.content_Id.passageData && q.content_Id.passageData.map((x: any) => contentIds.push(x.contentId))
			})
			if (this.qids) {
				this.qids.clear()
			}
			this.qids = new Set(contentIds)
		}
		return questions.map((q, i: number) => {
      quesListType = questionCode === 5 ? parseInt(q.qId.content[0].typeOfQuestion) : quesListType
      return (
      
			<div key={q.questionSerialNo} className={classes.paperSubSectionQuestion}>
				<div className={classes.metaInfoBoxTable}>
					<span>
						{
							questionCode === 5 ? this.renderQuestionScenario(q) : ''
						}
						<div className={classes.questionPreviewPara}>
							<div className={classes.widthMD}>
								<Typography variant="body2" className={classes.questionSerialNum}>Q{q.questionSerialNo}. </Typography>
							</div>
							<div className={classes.marginSM}>								
								<div>
									<Typography variant="body1">
										<span className={classes.questionContentLatex} dangerouslySetInnerHTML={{ __html: _.get(q, 'qId.content[0].questionContent', '-') }}></span>
										<span id="myBtn" className={[classes.viewMoreButton, classes.blueColor].join(' ')} onClick={this.handleReadMore.bind(this)}>View More</span>
									</Typography>
								</div>
							
							<div style={{ transform: 'translateY(-5px)' }}>
								<div></div>
								<div>
									<Typography variant="body1">
										<span className={classes.paperSubSectionQuestionId}>ID: </span>
										{q && q.qId && q.qId._id && (
										<MyPATLink style={{ display: 'initial' }} to={`/content/preview/${q.qId._id}question`} target="_blank">{_.get(q, 'qId.contentId', '-')}</MyPATLink>
										)}
									</Typography>
								</div>
							</div>
							</div>
							</div>
							<div className={classes.optionContainer}>
							{![6, 7, 3].includes(quesListType) ?
								<div>
									<div></div>
									<div>
										<Typography variant="body2" className={classes.fontSM}>Options are: </Typography>
									</div>
								</div> : ''
							}
							{[6, 7, 3].includes(quesListType) && q.qId.content[0].correctAnswer.data.length ?
								<>
									<div>
										<div></div>
										<div>Correct answer is &nbsp;<strong style={{ textAlign: 'center' }}>{q.qId.content[0].correctAnswer.data.map((answer: { value: any; }) => answer.value).join(', ')}</strong></div>
										<div></div>
									</div>
									{
										quesListType === 6 ?
											<>
												<br />
												<div>
													<div></div>
													<div>Positive tolerance is &nbsp;<strong>{q.qId.content[0].correctAnswer.data[0].positiveTolerance}</strong></div>
													<div></div>
												</div>
												<br />
												<div>
													<div></div>
													<div>Negative tolerance is &nbsp;<strong>{q.qId.content[0].correctAnswer.data[0].negativeTolerance}</strong></div>
													<div></div>
												</div>
											</>
											: ''
									}
								</> : ''
							}
							{![1, 3, 4, 6, 7].includes(quesListType) &&
								_.map(_.get(q, 'qId.content[0].optionsContent', []), (o, j: number) => (
									<>
									<div className={classes.successIcon}>
											{
												_.get(q, 'qId.content[0].correctAnswer.data', []).map((d: any) => d.value).includes(o.id)
												&& <SuccessIcon className={classes.successIcon} />
											}
									</div>
									<div key={j}>
										<div>
											<Typography variant="body1" component="div">
												<div className={classes.optionText}>&#40;{o.id}&#41; <span style={{ verticalAlign: 'middle' }} dangerouslySetInnerHTML={{ __html: o.value }}></span></div>
											</Typography>
										</div>
									</div>
									</>
								))
							}
							{[1].includes(quesListType) && q.qId.content[0].matrixOptionContent.optionRight.length && q.qId.content[0].matrixOptionContent.optionLeft.length ?
								<>
									<div>
										<div></div>
										<div style={{ display: 'flex' }}>
											<div style={{ width: '60%' }}>
												<strong style={{ textAlign: 'center' }}>Left Option</strong>
											</div>
											<div style={{ width: '40%' }}>
												<strong style={{ textAlign: 'center' }}>Right Option</strong>
											</div>
										</div>
									</div>
									{
										_.map(_.get(q, 'qId.content[0].matrixOptionContent.optionRight', []), (or, i: number) => {
											const leftOptionsLength = _.get(q, 'qId.content[0].matrixOptionContent.optionLeft', []).length;

											return (
												<div key={i}>
													<Typography variant="body1" component="div"></Typography>
													<div style={{ display: 'flex' }}>
														<div style={{ width: '60%' }}>
															<Typography variant="body1" component="div"><div className={classes.optionText}>{i <= leftOptionsLength - 1 ? `${i + 1}.` : ''}&nbsp;&nbsp;<span dangerouslySetInnerHTML={{ __html: _.get(q, 'qId.content[0].matrixOptionContent.optionLeft[' + i + '].value', []) }}></span></div></Typography>
														</div>
														<div style={{ width: '40%' }}><Typography variant="body1" component="div">
															<div className={classes.optionText}>
																{i + 1}.&nbsp;&nbsp;<span dangerouslySetInnerHTML={{ __html: or.value }}></span>
															</div>
														</Typography>
														</div>
													</div>
												</div>
											)
										})
									}
									<br />
									<br />
									<div>
										<div></div>
										<div className={classes.borderBox} style={{ width: 'auto', padding: '15px' }}>
											<Typography variant="subtitle1" className={classes.mb2x}>Correct Answer</Typography>
											<Table className={classes.answerTable}>
												<TableBody>
													<TableRow>
														<TableCell>&nbsp;</TableCell>
														{_.map(q.qId.content[0].matrixOptionContent.optionRight, (optionR, idxR: number) => <TableCell key={idxR}>{idxR + 1}</TableCell>)}
													</TableRow>

													{_.map(q.qId.content[0].correctAnswer.data, (correctOption, idxL: number) => (
														<TableRow key={idxL}>
															<TableCell style={{ verticalAlign: 'middle' }}>{idxL + 1}</TableCell>

															{_.map(q.qId.content[0].matrixOptionContent.optionRight, (optionR, idxR: number) => (
																<TableCell key={`${idxL}-${idxR}`}>
																	<Checkbox
																		checked={this.isChecked(optionR.id, correctOption.value)}
																		classes={{ checked: classes.checkboxChecked }}
																		disabled={true}
																	/>
																</TableCell>
															))}

														</TableRow>
													))}
												</TableBody>
											</Table>
										</div>
									</div>
								</>
								: null}
							</div>
					</span>
				</div>
			</div>
		)});
	}

	testPaperSyllabus = (subjectData: any, index: number) => {
		const { classes } = this.props;
		let subjectName = _.get(subjectData, 'subjectId.name', '');
		let chapterName: string[] = [];

		if (subjectData.subSubjects) {
			_.forEach(subjectData.subSubjects, (subSubject: any, i: number) => {
				_.forEach(subSubject.chapters, (chapter: any, i: number) => {
					chapterName.push(_.get(chapter, 'chapterId.name', ''))
				})
			})
		}

		chapterName = chapterName.filter(chapter => ![undefined, null, ''].includes(chapter));

		return (<Grid item key={index}>
			<div className={classes.syllabusBox}>
				<Typography variant="body2" className={[classes.syllabusSubject, classes.subHeadingFont].join(' ')}>{subjectName}</Typography>
				<Typography variant="body1" className={[classes.syllabusContains, classes.subHeadingFont].join(' ')}>{chapterName.join(', ')}</Typography>
			</div>
		</Grid>)
	}

	getGoalName = (courseId: any[]) => {
		if (!!courseId.length) {
			return Array.from(new Set(courseId.map((course: any) => course.courseType.name))).join(', ');
		}
		return '-'
	}

	toShowJEEMainSpecificFields = () => {
		const { content } = this.props
		if(content && content.content && content.content.courseId && !_.isEmpty(content.content.courseId)) {
			const containsJEEMainCourseId = content.content.courseId.find((course: any) => course === JEE_MAIN_COURSE_ID || course._id === JEE_MAIN_COURSE_ID);
			if(!containsJEEMainCourseId) {
				return false;
			}

			const { data } = content.content
			if(!data) {
				return false;
			}
			return _.get(data, 'sections[0].subSection[0].mandatoryQuestionCount', undefined) !== undefined
		}
		return false
	}

	render() {
		const { classes, content, clickedfeedbackData } = this.props;
    let testType = _.get(content, 'content.settings.testType', '');
    testType = testType === 'combined' ? 'Half Course' : testType;
    testType = testType ? testType + ' Test' : '-';
    testType = testType[0].toUpperCase() + testType.slice(1);
		return (
      <Grid container justify="center">
        <Grid item xs={12}>
          <Paper className={classes.paperOverview} elevation={0}>
            <MyPATExpansionPanel
              hasExpandIcon={false}
              variant="white"
              customCollapseTitle={
                <>
                  <div
                    className={
                      !this.props.openFeedback && classes.keyValueContainer
                    }
                  >
                    <Typography
                      variant="body2"
                      onClick={() => this.addFeedback("testName")}
                      className={classes.headingFontPreview}
                    >
                      <span
                        id={
                          this.props.openFeedback &&
                          this.state.tag === "testName"
                            ? "feedbackScroll"
                            : ""
                        }
                        className={`${classes.feedbackContainer} ${
                          this.props.openFeedback &&
                          this.state.tag === "testName"
                            ? classes.blueColor
                            : ""
                        } ${
                          this.props.openFeedback
                            ? classes.feedbackHighlight
                            : ""
                        }`}
                      >
                        Test Paper Name: &nbsp;
                        {this.props.openFeedback &&
                          this.state.tag === "testName" && (
                            <Grid className="feedbackBlock">
                              <AddFeedback
                                author={this.props.authorType}
                                replyFeedback={this.replyFeedback}
                                closeFeedback={this.closeFeedback}
                                resolveFeedback={this.resolveFeedback}
                                clickedfeedbackData={clickedfeedbackData}
                                addNewFeedback={this.addNewFeedback}
                              />
                            </Grid>
                          )}
                      </span>
                    </Typography>
                    <Typography className={classes.templateType} variant="body1">
                      {_.get(content, "content.name", "-")}
                    </Typography>
                  </div>
                </>
              }
            >
              <Typography
                variant="body1"
                className={[classes.overviewMeta].join(" ")}
              >
                Duration: {_.get(content, "content.settings.duration", "0")}
                min {/*1h 20min*/} | Test Type :{" "}
                {testType} | Goal:{" "}
                {this.getGoalName(_.get(content, "content.courseId", []))} | Bucket Type: {getContentBucketName(content)}
              </Typography>
              <div className={classes.metaInfoBox}>
                <Grid container>
                  <Grid item xs={6}>
                    <div className={classes.metaInfoBoxTable}>
                      <div className={classes.divTableRow}>
                        <div className={classes.divTableCol}>
                          <Typography
                            variant="body1"
                            className={classes.subHeadingFont}
                          >
                            No. of Attempts
                          </Typography>
                        </div>
                        <div
                          className={[
                            classes.divTableCol,
                            classes.widthSM,
                          ].join(" ")}
                        >
                          <Typography>&#58;</Typography>
                        </div>
                        <div className={classes.divTableCol}>
                          <Typography variant="body1">
                            {_.get(
                              content,
                              "content.settings.noOfAttempts",
                              "0"
                            )}
                          </Typography>
                        </div>
                      </div>
                      <div className={classes.divTableRow}>
                        <div className={classes.divTableCol}>
                          <Typography variant="body1">
                            Test Pause
                          </Typography>
                        </div>
                        <div
                          className={[
                            classes.divTableCol,
                            classes.widthSM,
                          ].join(" ")}
                        >
                          <Typography>&#58;</Typography>
                        </div>
                        <div className={classes.divTableCol}>
                          <Typography variant="body1">
                            {_.get(content, "content.settings.pause", "")
                              ? "Yes"
                              : "No"}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <div
                      className={[
                        classes.metaInfoBoxTable,
                        classes.subHeadingFont,
                      ].join(" ")}
                    >
                      <div className={classes.divTableRow}>
                        <div className={classes.divTableCol}>
                          <Typography variant="body1">Language</Typography>
                        </div>
                        <div
                          className={[
                            classes.divTableCol,
                            classes.widthSM,
                          ].join(" ")}
                        >
                          <Typography>&#58;</Typography>
                        </div>
                        <div className={classes.divTableCol}>
                          <Typography variant="body1">
                            {_.get(
                              content,
                              "content.settings.language",
                              []
                            ).join(",")}
                          </Typography>
                        </div>
                      </div>
                      <div className={classes.divTableRow}>
                        <div className={classes.divTableCol}>
                          <Typography variant="body1">Shuffle</Typography>
                        </div>
                        <div
                          className={[
                            classes.divTableCol,
                            classes.widthSM,
                          ].join(" ")}
                        >
                          <Typography>&#58;</Typography>
                        </div>
                        <div className={classes.divTableCol}>
                          <Typography variant="body1">
                            { this.getShuffleParamters()}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </MyPATExpansionPanel>
          </Paper>
        </Grid>
        {_.get(content, "subjects", []).length ? (
          <Grid item xs={12}>
            <Paper className={classes.paperSyllabus} elevation={0}>
              <Typography
                variant="body2"
                onClick={() => this.addFeedback("testSyllabus")}
                className={classes.headingFont}
              >
                <span
                  id={
                    this.props.openFeedback &&
                    this.state.tag === "testSyllabus"
                      ? "feedbackScroll"
                      : ""
                  }
                  className={`${classes.feedbackContainer} ${
                    this.props.openFeedback &&
                    this.state.tag === "testSyllabus"
                      ? classes.blueColor
                      : ""
                  } ${
                    this.props.openFeedback ? classes.feedbackHighlight : ""
                  }`}
                >
                  Test Paper Syllabus:
                  {this.props.openFeedback &&
                    this.state.tag === "testSyllabus" && (
                      <Grid className="feedbackBlock">
                        <AddFeedback
                          author={this.props.authorType}
                          replyFeedback={this.replyFeedback}
                          closeFeedback={this.closeFeedback}
                          resolveFeedback={this.resolveFeedback}
                          clickedfeedbackData={clickedfeedbackData}
                          addNewFeedback={this.addNewFeedback}
                        />
                      </Grid>
                    )}
                </span>
              </Typography>
              <Grid container direction="column" spacing={8}>
                {_.map(content.subjects, (subject, index: number) => (
                  <div key={index}>
                    {this.testPaperSyllabus(subject, index)}
                  </div>
                ))}
              </Grid>
            </Paper>
          </Grid>
        ) : null}
        {this.props.fromFeedback && (
          <>
            <Grid item xs={12}>
              <Paper className={classes.paperSyllabus} elevation={0}>
                <Typography
                  variant="body2"
                  onClick={() => this.addFeedback("testSection")}
                  className={classes.headingFont}
                >
                  <span
                    id={
                      this.props.openFeedback &&
                      this.state.tag === "testSection"
                        ? "feedbackScroll"
                        : ""
                    }
                    className={`${classes.feedbackContainer} ${
                      this.props.openFeedback &&
                      this.state.tag === "testSection"
                        ? classes.blueColor
                        : ""
                    } ${
                      this.props.openFeedback
                        ? classes.feedbackHighlight
                        : ""
                    }`}
                  >
                    Test Questions:
                    {this.props.openFeedback &&
                      this.state.tag === "testSection" && (
                        <Grid className="feedbackBlock">
                          <AddFeedback
                            author={this.props.authorType}
                            replyFeedback={this.replyFeedback}
                            closeFeedback={this.closeFeedback}
                            resolveFeedback={this.resolveFeedback}
                            clickedfeedbackData={clickedfeedbackData}
                            addNewFeedback={this.addNewFeedback}
                          />
                        </Grid>
                      )}
                  </span>
                </Typography>
                <Grid container direction="column" spacing={8}>
                  <Paper>
                    {_.map(
                      _.get(content, "content.data.sections", []),
                      (section, i: number) => (
                        <Grid item key={i} xs={12}>
                          {this.section(section, i)}
                        </Grid>
                      )
                    )}
                  </Paper>
                </Grid>
              </Paper>
            </Grid>
          </>
        )}
        {!this.props.fromFeedback && (
          <>
            <Paper className={classes.paperContainer}>
				<Typography className={classes.headingFont}>Test Questions:</Typography>
              {_.map(
                _.get(content, "content.data.sections", []),
                (section, i: number) => (
                  <Grid item key={i} xs={12}>
                    {this.section(section, i)}
                  </Grid>
                )
              )}
            </Paper>
          </>
        )}
      </Grid>
    );
	}
}

const mapStateToProps = (state: any) => ({
});
const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
    addNewFeedback: addNewFeedback,
    resolveFeedback: resolveFeedback,
    replyFeedback: replyFeedback
  },
  dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TestPreview));
